import { InjectionToken } from '@angular/core';
import type { AzureConfig } from './azure-config';

export const AUTH_CONFIG = new InjectionToken<AzureConfig>('AZURE_AUTH_CONFIG');
